"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLSearchParams = void 0;
/**
 * Implementation of the URLSearchParams interface.
 * To be used in conjunction with the TransportClient
 * while building requests.
 */
var URLSearchParams = /** @class */ (function () {
    function URLSearchParams() {
        this.params = new Map();
    }
    URLSearchParams.prototype.set = function (name, value) {
        this.params.set(name, value);
    };
    URLSearchParams.prototype.delete = function (name) {
        this.params.delete(name);
    };
    URLSearchParams.prototype.get = function (name) {
        return this.params.get(name);
    };
    URLSearchParams.prototype.has = function (name) {
        return this.params.has(name);
    };
    URLSearchParams.prototype.isEmpty = function () {
        return this.params.size === 0;
    };
    URLSearchParams.prototype.toString = function () {
        return Array.from(this.params)
            .map(function (_a) {
            var key = _a[0], value = _a[1];
            return "".concat(key, "=").concat(value);
        })
            .join('&');
    };
    return URLSearchParams;
}());
exports.URLSearchParams = URLSearchParams;
